import axios from "axios"
import { saveAs } from "file-saver"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
export default {
  // In frontend/src/api/index.js innerhalb des default exports einfügen.
  // (Dieser Block ist als Erweiterung des bestehenden api-Objekts gedacht.)

  marketingShop: {
    // ===== Produkte =====
    fetchProducts(params = {}) {
      const url = buildUrl("marketing-shop/products")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
    fetchProduct(id) {
      const url = buildUrl(`marketing-shop/products/${id}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    createProduct(formData) {
      const url = buildUrl("marketing-shop/products")
      const options = buildOptions()
      if (options.headers["Content-Type"]) delete options.headers["Content-Type"]
      return axios.post(url, formData, options).then((res) => res.data)
    },
    updateProduct(id, formData) {
      const url = buildUrl(`marketing-shop/products/${id}`)
      const options = buildOptions()
      if (options.headers["Content-Type"]) delete options.headers["Content-Type"]
      return axios.put(url, formData, options).then((res) => res.data)
    },
    deleteProduct(id) {
      const url = buildUrl(`marketing-shop/products/${id}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },
    loadProductImage(productId, fileId) {
      const url = buildUrl(`marketing-shop/products/${productId}/image/${encodeURIComponent(fileId)}`)
      return axios.get(url, { responseType: "blob", headers: { Authorization: localStorage.getItem("token") } }).then((response) => {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"] || "application/octet-stream",
        })
        return URL.createObjectURL(blob)
      })
    },
    // Admin-Preview Download des Digital-Files
    downloadProductFile(productId, filename = "download.pdf") {
      const url = buildUrl(`marketing-shop/products/${productId}/file`)
      return axios.get(url, { responseType: "blob", headers: { Authorization: localStorage.getItem("token") } }).then((response) => {
        const blob = response.data
        if (window.flutter_inappwebview) {
          const reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onloadend = function () {
            const base64 = reader.result.split(",")[1]
            window.flutter_inappwebview.callHandler("blobToBase64Handler", base64.toString(), "pdf", filename.replace(/\.pdf$/i, ""))
          }
        } else {
          // Browser-Fallback
          const downloadUrl = URL.createObjectURL(blob)
          const a = document.createElement("a")
          a.href = downloadUrl
          a.download = filename
          document.body.appendChild(a)
          a.click()
          a.remove()
          setTimeout(() => URL.revokeObjectURL(downloadUrl), 5000)
        }
      })
    },

    // ===== Bestellungen =====
    fetchOrders(params = {}) {
      const url = buildUrl("marketing-shop/orders")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
    fetchOrder(id) {
      const url = buildUrl(`marketing-shop/orders/${id}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    createOrder(data) {
      const url = buildUrl("marketing-shop/orders")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    updateOrder(id, data) {
      const url = buildUrl(`marketing-shop/orders/${id}`)
      return axios.put(url, data, buildOptions()).then((res) => res.data)
    },
    updateOrderStatus(id, status) {
      const url = buildUrl(`marketing-shop/orders/${id}/status`)
      return axios.put(url, { status }, buildOptions()).then((res) => res.data)
    },
    addOrderComment(id, comment) {
      const url = buildUrl(`marketing-shop/orders/${id}/comments`)
      return axios.post(url, { comment }, buildOptions()).then((res) => res.data)
    },
    deleteOrder(id) {
      const url = buildUrl(`marketing-shop/orders/${id}`)
      return axios.delete(url, buildOptions()).then((res) => res.data)
    },
    /**
     * Lädt das Digital-File eines Order-Items herunter.
     * Nutzt Flutter-Bridge auf Mobile, file-saver Logik im Web.
     */
    downloadOrderItemFile(orderId, itemIdx, filename = "download.pdf") {
      const url = buildUrl(`marketing-shop/orders/${orderId}/items/${itemIdx}/file`)
      return axios.get(url, { responseType: "blob", headers: { Authorization: localStorage.getItem("token") } }).then((response) => {
        const blob = response.data
        if (window.flutter_inappwebview) {
          const reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onloadend = function () {
            const base64 = reader.result.split(",")[1]
            window.flutter_inappwebview.callHandler("blobToBase64Handler", base64.toString(), "pdf", filename.replace(/\.pdf$/i, ""))
          }
        } else {
          const downloadUrl = URL.createObjectURL(blob)
          const a = document.createElement("a")
          a.href = downloadUrl
          a.download = filename
          document.body.appendChild(a)
          a.click()
          a.remove()
          setTimeout(() => URL.revokeObjectURL(downloadUrl), 5000)
        }
      })
    },
    fetchInventory(params = {}) {
      const url = buildUrl("marketing-shop/inventory")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },
  },
  getMyPrintRequests() {
    let url = buildUrl("prints/my-requests")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  uploadPrintMedia(formData) {
    let url = buildUrl("prints/upload")
    return axios.post(url, formData, buildOptions()).then((res) => res.data)
  },
  requestPrint(data) {
    let url = buildUrl("prints/request")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  getPendingPrints() {
    let url = buildUrl("prints/pending")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  handlePrintRequest(id, data) {
    // data = { status: 'approved' oder 'rejected', rejectionReason: '...' }
    let url = buildUrl(`prints/${id}/handle`)
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  // ... deine bestehenden API calls ...
  fetchHyroxPFTEventAvailability() {
    const url = buildUrl(`hyrox/pft/availability`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  // --- HYROX PFT ADMIN ---
  fetchHyroxRegistrations(params = {}) {
    // params kann z.B. { block: 1, status: 'active' } sein
    const queryStr = new URLSearchParams(params).toString()
    const url = buildUrl(`hyrox/pft/admin/registrations${queryStr ? "?" + queryStr : ""}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  updateHyroxPayment(id, data) {
    const url = buildUrl(`hyrox/pft/admin/registration/${id}/payment`)
    return axios.patch(url, data, buildOptions()).then((res) => res.data)
  },

  deleteHyroxRegistration(id) {
    const url = buildUrl(`hyrox/pft/admin/registration/${id}`)
    return axios.delete(url, buildOptions()).then((res) => res.data)
  },
  // Slides
  fetchParties() {
    // Holt alle aktiven Parties für den Slider
    let url = buildUrl("party/active")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchAllParties() {
    // Für das Admin Dashboard
    let url = buildUrl("party/all")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  saveParty(party) {
    let url = buildUrl("party")
    return axios.post(url, { party }, buildOptions()).then((res) => res.data)
  },
  uploadPartyImage(formData) {
    // Der Endpunkt muss mit dem in upload_party.js übereinstimmen (/api/upload/party)
    let url = buildUrl("upload/party")
    return axios.post(url, formData, buildOptions()).then((res) => res.data)
  },
  signupParty(partyId) {
    let url = buildUrl(`party/signup/${partyId}`)
    return axios.post(url, {}, buildOptions()).then((res) => res.data)
  },
  signoffParty(partyId) {
    let url = buildUrl(`party/signoff/${partyId}`)
    return axios.post(url, {}, buildOptions()).then((res) => res.data)
  },
  fetchSlides() {
    let url = buildUrl("slides")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchMainSlider() {
    let url = buildUrl("main/slider")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  saveSlide(slide) {
    let url = buildUrl("slide")
    return axios.post(url, { slide }, buildOptions()).then((res) => res.data)
  },

  // Popups
  savePopup(popup) {
    let url = buildUrl("notifications/popup")
    return axios.post(url, { popup }, buildOptions()).then((res) => res.data)
  },
  followLinkPopup(id) {
    let url = buildUrl("notifications/popup/lead/" + id)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  readPopup(id) {
    let url = buildUrl("notifications/popup/read/" + id)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchPopups() {
    let url = buildUrl("notifications/popups")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  fetchPopup() {
    let url = buildUrl("notifications/popup")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  // QR-Code
  fetchQRCode(link) {
    let url = buildUrl("qrcode/image?data=" + link)
    axios({
      url, //your url
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      if (window.flutter_inappwebview) {
        var reader = new FileReader()
        reader.readAsDataURL(response.data)
        reader.onloadend = function () {
          var dataUrl = reader.result
          var base64 = dataUrl.split(",")[1]
          console.log(base64)
          window.flutter_inappwebview.callHandler("blobToBase64Handler", base64.toString(), "png", "qrCode")
        }
      } else {
        saveAs(response.data, "qrCode")
      }
    })
  },

  // News

  getNews(studio) {
    let url = buildUrl(`news`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  markNewsAsRead(newsId) {
    let url = buildUrl("news/" + newsId + "/read")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getNewsCount() {
    let url = buildUrl(`news/count`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  getAllNews(studio) {
    let url = buildUrl(`allnews`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  saveNews(news) {
    let url = buildUrl(`news`)
    return axios.put(url, { news }, buildOptions()).then((res) => res.data)
  },
  createNews(news) {
    let url = buildUrl(`news`)
    return axios.post(url, news, buildOptions()).then((res) => res.data)
  },

  // Campaigns

  submitAdventsverlosung(fd) {
    let url = buildUrl("adventsverlosung")
    return axios.post(url, fd).then((res) => res.data)
  },

  listAdventsverlosung() {
    let url = buildUrl("adventsverlosung")
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  createCampaign(campaign) {
    let url = buildUrl(`campaign`)
    return axios.post(url, campaign, buildOptions()).then((res) => res.data)
  },
  signupCampaign(campaign_id, userid, studio_id) {
    let url = buildUrl(`campaignsignup/${campaign_id}`)
    return axios.post(url, { user_id: userid, studio_id: studio_id }, buildOptions()).then((res) => res.data)
  },
  signoffCampaign(campaign_id, userid) {
    let url = buildUrl(`campaignsignoff/${campaign_id}`)
    return axios.post(url, { user_id: userid }, buildOptions()).then((res) => res.data)
  },
  copyCampaign(campaign) {
    let url = buildUrl(`copycampaign`)
    return axios.post(url, { campaign: campaign }, buildOptions()).then((res) => res.data)
  },
  deleteCampaign(campaign) {
    let url = buildUrl(`deletecampaign`)
    return axios.post(url, { campaign: campaign }, buildOptions()).then((res) => res.data)
  },
  getKampagne(id) {
    let url = buildUrl(`kampagne/${id}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getCampaign(studio) {
    let url = buildUrl(`campaign/${studio}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getCampaignList(id) {
    let url = buildUrl(`campaignlist/${id}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  getAllCampaigns() {
    let url = buildUrl(`allcampaigns/`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },

  // Invites

  deleteWeiterempfehlung(id) {
    let url = buildUrl(`invites/delete/${id}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  updateInvite(data) {
    let url = buildUrl("invites/update")

    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  getInvites(data) {
    let url = buildUrl(`invites/studio/${data.filter}/${data.studio}`)
    return axios.get(url, buildOptions()).then((res) => res.data)
  },
  searchInvites(data) {
    let url = buildUrl("invites/search")
    return axios.post(url, data, buildOptions()).then((res) => res.data)
  },
  sendSchnuppermail(data) {
    let url = buildUrl("schnuppermail")
    return axios.post(url, data).then((res) => res.data)
  },
  // --- HYROX SCORE EVENT ---
  hyroxScore: {
    fetchAvailability() {
      const url = buildUrl("hyrox-score/availability")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    register(data) {
      const url = buildUrl("hyrox-score/register")
      return axios.post(url, data, buildOptions()).then((res) => res.data)
    },
    confirmPayment(registrationId) {
      const url = buildUrl("hyrox-score/confirm-payment")
      return axios.post(url, { registrationId }, buildOptions()).then((res) => res.data)
    },
    payment: {
      createSession(data) {
        const url = buildUrl("hyrox-score/payment/create-session")
        return axios.post(url, data, buildOptions()).then((res) => res.data)
      },
      verify(transactionId, redirectResult = null, pspReference = null) {
        const url = buildUrl("hyrox-score/payment/verify-payment")
        return axios.post(url, { transactionId, redirectResult, pspReference }, buildOptions()).then((res) => res.data)
      },
    },
    admin: {
      fetchRegistrations() {
        const url = buildUrl("hyrox-score/admin/registrations")
        return axios.get(url, buildOptions()).then((res) => res.data)
      },
      updateStatus(registrationId, statusData) {
        const url = buildUrl("hyrox-score/admin/update-status")
        return axios.post(url, { registrationId, ...statusData }, buildOptions()).then((res) => res.data)
      },
      toggleLimit(limit) {
        const url = buildUrl("hyrox-score/admin/toggle-limit")
        return axios.post(url, { limit }, buildOptions()).then((res) => res.data)
      },
      saveSettings(settings) {
        const url = buildUrl("hyrox-score/admin/settings")
        return axios.post(url, settings, buildOptions()).then((res) => res.data)
      },
      fetchUserDetails(userId) {
        const url = buildUrl("hyrox-score/admin/user/" + userId)
        return axios.get(url, buildOptions()).then((res) => res.data)
      },
      manualRegister(data) {
        const url = buildUrl("hyrox-score/admin/manual-register")
        return axios.post(url, data, buildOptions()).then((res) => res.data)
      },
      exportCsvUrl() {
        return buildUrl("hyrox-score/admin/export")
      },
    },
  },
}
